<template>
  <div class="devices">

    <b-card no-body>
      <b-tabs v-model="tabIndex" card>

        <!-- Render Tabs, supply a unique `key` to each tab -->
        <b-tab v-for="(data, index) in locationTabs" :key="index" :title="data.alias">
          <devices-pages  :location="data" 
                          :selectedTab="tabIndex"
                          @locationdeleted="closeTab"
                          @editcancelled="retrieveLocation" />
        </b-tab>

        <!-- New Tab Button (Using tabs-end slot) -->
        <template v-slot:tabs-end v-if="isUserAdmin()">
          <b-nav-item role="presentation" @click.prevent="newTabLocation" href="#">
            <b>+ Agregar nueva zona</b>
          </b-nav-item>
        </template>

        <!-- Render this if no tabs -->
        <template v-slot:empty>
          <div class="text-center text-muted">
            Todavía no hay ninguna zona agregada<br>
            Agrege una nueva zona usando el botón <b>+ Agregar nueva zona</b> situado arriba.
          </div>
        </template>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>

import Devicespages from '@/components/devices/DevicesPages';
import LocationService from "@/services/LocationService";
import UserService from '@/services/UserService';

export default {
    data () {
        return {
          tabIndex: 0,
          locationTabs: [],
        }
    },  
    components: {
      'devices-pages': Devicespages
    },
    mounted() {
      this.retrieveLocation();
    },
    methods: {

      async retrieveLocation() {
        try {
          let responseSelect = await LocationService.getAll();
          this.locationTabs = responseSelect.data;
        } catch (error) {
          throw new Error('Error - DeviceList.vue - retrieveLocation' + error);
        } 
      },

      async newTabLocation() {
        
        try {
          
          //Change tab to the new one
          let newIndex = this.locationTabs.length
          
          var data = {
            alias: 'Zona ' + (newIndex+1),
            type: null,
            location: {
              zip: '00000',
              province: 'Provincia',
              latitude: '0',
              longitude: '0'
            }
          };

          let responseCreate = await LocationService.create(data);

          let responseSelect = await LocationService.getAll();
          this.locationTabs = responseSelect.data;

          // No se cambia el tab automáticamente porque no funciona.  
          /*this.$nextTick(() => {
            requestAnimationFrame(() => {
              this.tabIndex = this.locationTabs.length + 1;
            })
          });*/
          
          this.$notify({
            group: 'notificateDiv',
            type: 'success',
            title: responseCreate.data.message ? responseCreate.data.message : 'Ubicación agregada correctamente',
            text: responseCreate.data.message ? "" : 'Se ha agregado 1 nueva ubicación a la lista',
            duration: 3000,
            speed: 1000
          });

        } catch (error) {
          if(error.response && error.response.data && error.response.data.message){
            console.log(error.response.data.message);
          }
          throw new Error('Error - DeviceList.vue - newTabLocation' + error);
        }
      },

      //TABPAGES PARAMS
      closeTab(id) {
        for (let i = 0; i < this.locationTabs.length; i++) {
          if (this.locationTabs[i]._id === id) {
            this.locationTabs.splice(i, 1)
          }
        }
      },

      isUserAdmin(){
        return UserService.isUserAdmin();
      }
    }
}
</script>
